import { render, staticRenderFns } from "./UserPhotoUpload.vue?vue&type=template&id=6da816a3&scoped=true"
import script from "./UserPhotoUpload.vue?vue&type=script&lang=js"
export * from "./UserPhotoUpload.vue?vue&type=script&lang=js"
import style0 from "./UserPhotoUpload.vue?vue&type=style&index=0&id=6da816a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da816a3",
  null
  
)

export default component.exports